import { Copy, Pencil, ThumbsDown, ThumbsUp } from "lucide-react";
import "./AgentChatResponseToolbar.css";

import { handleCopyText } from "../uiHelpers";

import { AIResponseMessage } from "./types";
import { FeedbackRating } from "./FeedbackRating";

type AgentChatResponseToolbarProps = {
  message: AIResponseMessage;
  children?: React.ReactNode;
};

export const AgentChatResponseToolbar = ({
  message,
  children,
}: AgentChatResponseToolbarProps) => {
  const handleCopy = async () => {
    console.log("Copy");
    handleCopyText(message.message.kwargs.content);
  };

  return (
    <div className="agent-chat-response-toolbar">
      <div className="agent-chat-response-toolbar-item" onClick={handleCopy}>
        <Copy size={16} />
      </div>
      {/* <div
        className="agent-chat-response-toolbar-item"
        onClick={() => toast("Thanks for the feedback!", toastSuccess)}>
        <ThumbsUp size={16} />
      </div>
      <div
        className="agent-chat-response-toolbar-item"
        onClick={() => toast("Thanks for the feedback!", toastSuccess)}>
        <ThumbsDown size={16} />
      </div>
      <div className="agent-chat-response-toolbar-item">
        <Pencil size={16} />
      </div> */}
      {children}
      {/* Hardcoded feedback rating for now */}
      <div className="">
        <FeedbackRating
          feedbackRating={message.feedbackRating}
          messageId={message.id}
        />
      </div>
    </div>
  );
};
